import React, {CSSProperties, ReactElement} from 'react';

import './placeholderBlock.scss';

export enum variants {
  quarter = 'quarter',
  third = 'third',
  half = 'half',
  threeQuarters = 'threeQuarters',
  full = 'full',
}

interface Props {
  variant?: variants;
  className?: string;
  style?: CSSProperties;
}

function PlaceholderBlock({variant, className, style = {}}: Props): ReactElement {
  return (
    <div
      data-testid="layout.placeholderBlock"
      className={`placeholderBlock ${variant ? `placeholderBlock--${variant}` : ''}${
        className ? ` ${className}` : ''
      }`.trim()}
      style={style}
    />
  );
}

export default PlaceholderBlock;
